'use client';

import { useState } from 'react';
import { ReferralData } from './referralData';

const faqs = [
  {
    q: 'Who is eligible for the Refer & Earn program?',
    a: 'The program is open to existing Amity Online learners and alumni. You can start referring and earning rewards right away.',
  },
  {
    q: 'What is considered a successful referral?',
    a: 'A referral is considered successful when the person you referred completes their enrollment and pays their first semester fees.',
  },
  {
    q: 'What reward will I receive?',
    a: 'You can earn up to ₹15,000 per successful referral, with higher rewards as you climb the Silver, Gold, and Platinum tiers.',
  },
  {
    q: 'Is there any benefit for the person I refer?',
    a: 'Yes. Your referred friend receives a welcome benefit of up to 25% off on their first semester fees.',
  },
  {
    q: 'What happens if my referred friend cancels their admission?',
    a: 'If the referred friend cancels their admission or does not complete fee payment, the referral will not be counted and no reward will be issued.',
  },
  {
    q: 'Can I refer someone who is already in touch with Amity Online?',
    a: 'Referrals are valid only for new prospects. If the person is already in active contact with Amity Online, the referral may not qualify.',
  },
  {
    q: 'What if my friend enrolls through another channel?',
    a: 'Rewards are issued only when the enrollment is completed through your referral. Enrollments made via other channels will not be counted.',
  },
  {
    q: 'Is there a limit to how many people I can refer?',
    a: 'No, there is no cap on referrals. The more you refer, the more you earn and the higher your tier.',
  },
  {
    q: 'How will I track my referrals?',
    a: 'You can track the real-time status of all your referrals from your referral dashboard.',
  },
  {
    q: 'Who is eligible for this referral program?',
    a: 'All enrolled Amity Online students and alumni are eligible to participate in the referral program.',
  },
  {
    q: 'Till when is this offer valid?',
    a: 'The offer is valid until further notice. Amity Online reserves the right to update the validity period at any time.',
  },
  {
    q: 'Can Amity modify or cancel the referral program?',
    a: 'Yes. Amity Online reserves the right to modify, pause, or cancel the referral program at its discretion.',
  },
];

export default function ReferralFaq({ data }: { data?: ReferralData['FAQ'] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  const cmsItems = data?.FAQitems;
  const renderFaqs =
    cmsItems && cmsItems.length
      ? cmsItems.map((f) => ({ q: f.question || '', a: f.answer || '' }))
      : faqs;

  return (
    <section className="bg-white pt-12 ">
      <div className="px-4 md_2:px-12 max-w-[1320px] mx-auto">
        <h2 className="text-[44px] sm:text-3xl md_2:text-[34px] font-bold text-[#1A325D] mb-8 md_2:mb-10 text-left md_2:text-center">
          FAQs
        </h2>

        <div className="divide-y divide-gray-200 border-t border-gray-200">
          {renderFaqs.map((faq, i) => (
            <div key={i}>
              <button
                type="button"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
                className="w-full flex items-start justify-between gap-4 py-5 md_2:py-5 px-0 text-left focus:outline-none"
              >
                <span className="text-base md_2:text-lg font-medium text-[#1A325D] leading-snug">
                  {faq.q}
                </span>
                <span className="text-[#1A325D] font-light text-3xl w-6 text-center flex-shrink-0 leading-none">
                  {openIndex === i ? '−' : '+'}
                </span>
              </button>
              {openIndex === i && (
                <p className="sm:text-sm text-base  text-gray-600 leading-relaxed pb-5 pr-10">
                  {faq.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
